import { createStyles, makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function () {
  return createStyles({
    root: {
      padding: function padding(props) {
        return props != null && props.justContent ? 0 : props != null && props.icon ? '6px 12px' : 'auto';
      },
      '& .MuiListItemIcon-root': {
        minWidth: 35
      },
      '& .MuiListItemText-primary': {
        fontSize: 15
      }
    }
  });
});
export default useStyles;